import script from "./NewCardModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewCardModal.vue?vue&type=script&setup=true&lang=ts"

import "./NewCardModal.vue?vue&type=style&index=0&id=df6d8ed2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-df6d8ed2"]])

export default __exports__